import React, { Component } from 'react';

import _ from 'lodash';
import { observable, autorun, action, toJS, computed } from 'mobx';
import { observer } from 'mobx-react'

import {DictionaryTrans,autobind} from './DictionaryTrans';
import reactMixin  from 'react-mixin';
import Settings from './Settings';
import {constFonts} from './constFonts';

@observer
@reactMixin.decorate(DictionaryTrans)
@reactMixin.decorate(autobind(Object.keys(DictionaryTrans)))
export default class BaseText  extends Component  {


  @observable trans = { };
  @observable showTextPicker = false;
  @observable currentTextColor = '';
  @observable currentFontSize = 12;
  @observable currentFontSpace = 12;

  @observable showTipFontSize = false;

  @observable currentFontStyle = {
    fontWeight: 'normal',
    textDecoration: 'none',
    fontStyle: 'normal',
    textAlign: 'left'
  }

  @observable currentFontFamily = {
    label : 'Roboto',
    type : 'element',
  }

  fonts = constFonts;

  constructor(props) {

    super(props)

    this.trans = this.props.dictionaryStorage.getCurrentLangDict;
    this.bindEvents();

  }

  bindEvents(){
    $(window).on('WorkArea-selectCanvasElem',(e,active)=>{


      if ( active.type != 'i-text' &&  active.type != 'textbox' ) return;

      var idLayer = active.idLayer;
      this.currentFontSize = active.fontSize;
      this.currentFontSpace = active.charSpacing;
      this.currentTextColor = active.fill;
      this.currentFontFamily = {
        label : active.fontFamily,
        type : 'element'
      }

     // setFontStyleView(active);

    });

    $(window).on('WorkArea-deselectCanvasElem',(e,active)=>{
      this.activeTextArea = false;
    })
  }

  onChoiceColor(color){

    this.currentTextColor = '#'+color;
    Settings.setCurrentFontColor('#'+color);


  }

  toggleTextColorPicker(){
    this.showTextPicker = !this.showTextPicker;
  }

  fontRenderOption(option) {
    if ( option.type == 'header' )
    {
      return (
        <p className="Text-SelectHeader">{option.label}</p>
      );
    }
    else
    {
      return (
        <p className="Text-SelectElement" style={{'fontFamily':option.label}}>{option.label}</p>
      );
    }
  }

  renderValue(option) {
    return <p className="Text-SelectValue"  style={{'fontFamily':option.label}}>{option.label}</p>;
  }

  changeFontFamily(val){
    if ( val.type == 'header') return;
    this.currentFontFamily = val;
    Settings.setCurrentFontFamily(val);

  }

  currentFontSizeInputChange(e) {
    let val = e.target.value;

    this.changeFontSize(val)

  }

  @computed get currentFontSizeInput() {
    let res = Math.round(this.currentFontSize / 10);
    if ( isNaN(res) ) return 0;
    return res;
  }

  changeFontSize(val){
    if ( !isNaN(val))
    {
      //this.currentFontSize = Math.round(val);
      let val_round = Math.round(val);
      Settings.setCurrentFontSize(val_round);

    }
  }

  changeFontSpace(element){
    //this.currentFontSpace = element.value;
    Settings.setCurrentFontSpace(element.value);

  }

  setFontStyle(key,val){
    Settings.setCurrentFontStyle(key,val);


  }


}


